// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"bf54a971","308":"982e2728","374":"01457789","859":"4a157967"}[chunkId] + ".chunk.js";
};